module.exports = __webpack_public_path__ + "static/media/anke-burgmer.8bc38a3e.jpg";